import * as constants from './constants';

const appendScript = (scriptUrl) => {
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  document.body.appendChild(script);
};

const initFB = ({ callback = () => {}, appId }) => {
  appendScript('https://connect.facebook.net/en_US/sdk.js');
  window.fbAsyncInit = () => {
    FB.init({
      appId,
      cookie: true,
      xfbml: true,
      version: `v${constants.FACEBOOK_API_VERSION}`,
    });
    callback();
  };
};

export default initFB;
